import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './QueueFlyoutTab.scss';

var QueueFlyoutTab = /*#__PURE__*/function (_Component) {
  _inherits(QueueFlyoutTab, _Component);

  var _super = _createSuper(QueueFlyoutTab);

  function QueueFlyoutTab() {
    _classCallCheck(this, QueueFlyoutTab);

    return _super.apply(this, arguments);
  }

  _createClass(QueueFlyoutTab, [{
    key: "render",
    value: function render() {
      return !this.props.label ? null : /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.tab, " ").concat(this.props.isSelected ? styles.selected : ''),
        onClick: this.props.onClick,
        style: this.props.style
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.tabText,
        style: {
          height: 18
        }
      }, this.props.label));
    }
  }]);

  return QueueFlyoutTab;
}(Component);

_defineProperty(QueueFlyoutTab, "propTypes", {
  label: PropTypes.node,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
  style: PropTypes.object
});

_defineProperty(QueueFlyoutTab, "defaultProps", {
  style: {}
});

export { QueueFlyoutTab as default };